import { render } from "./AddAgent.vue?vue&type=template&id=68799a76&scoped=true"
import script from "./AddAgent.vue?vue&type=script&lang=js"
export * from "./AddAgent.vue?vue&type=script&lang=js"

import "./AddAgent.vue?vue&type=style&index=0&id=68799a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68799a76"]])

export default __exports__